import { Question } from '@playbooks/core/src/interfaces'

import { SignatureData } from '../../../types'
import { QuestionNode } from '../../../actionCard'

export class SignatureQuestionNode extends QuestionNode {
  declare data: Question<SignatureData>

  public override getStringValue(): string {
    // non supported
    console.warn('Getting string value is not supported for SignatureQuestionNode')
    return ''
  }

  public override setStringValue(_value: string): void {
    // non supported
    console.warn('Setting string value is not supported for SignatureQuestionNode')
  }

  public override stringifyValue(): string {
    const value = this.getValue() as SignatureData

    return !!value?.points?.length ? '✅' : '❌'
  }

  public override isInputEmpty(): boolean {
    const value = this.getValue()
    return !value || !value.points || value.points.length === 0
  }
}
